<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>공영주차장</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">공영주차장</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/unpaidinfo" title="주차요금정산">주차요금정산</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">노외주차장 검색</p>
          <ul class="depth">
            <li><router-link to="/map" title="노외주차장 검색">노외주차장 검색</router-link></li>
            <li><router-link to="/parkfeeinformation" title="주차장 이용안내">주차장 이용안내</router-link></li>
            <li><router-link to="/parkfeereduction" title="주차요금 감면안내">주차요금 감면안내</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">지도 검색</p>
          <ul class="depth">
            <li><router-link to="/map" title="지도 검색">지도 검색</router-link></li>
            <li><router-link to="/list" title="주소 검색">주소 검색</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <div id="tabs">
          <ul class="tabMenu">
            <li class="active"><router-link to="/map" title="지도 검색">지도 검색</router-link></li>
            <li><router-link to="/list" title="주소 검색">주소 검색</router-link></li>
          </ul>
          <section class="tabCont">
            <article class="parkRadio">
              <dl role="radiogroup">
                <dt>거리</dt>
                <dd>
                  <input
                    type="radio"
                    v-model="distance"
                    value="500"
                    id="d500m"
                    name="distance"
                    @change="distanceCheck($event)"
                  />
                  <label for="d500m">500m 이내</label>
                </dd>
                <dd>
                  <input
                    type="radio"
                    v-model="distance"
                    value="1000"
                    id="d1Km"
                    name="distance"
                    @change="distanceCheck($event)"
                  />
                  <label for="d1Km">1km 이내</label>
                </dd>
                <dd>
                  <input
                    type="radio"
                    v-model="distance"
                    value=""
                    id="d1KmUp"
                    name="distance"
                    @change="distanceCheck($event)"
                  />
                  <label for="d1KmUp">1km 이상</label>
                </dd>
              </dl>
            </article>

            <div class="parkArea">
              <!--지도-->
              <div id="mapContainer">
                <!-- 로드뷰 화면 들어갈 곳 -->

                <div id="rvWrapper">
                  <div id="roadview" class="mapWH100"></div>
                  <div id="close" title="로드뷰닫기" @click="closeRoadview()"><span class="img"></span></div>
                </div>

                <!-- Map 화면 들어갈 곳 -->
                <div class="view_roadview">
                  <div id="parkingMapWrapper" class="mapWH100">
                    <KakaoMap
                      :centerPositions="mapCenterPosition"
                      :parkingList="parkingList"
                      @kakaoMapMarker="kakaoMapMarker"
                    />
                  </div>
                  <div id="roadviewControl" :class="{ active: active === true }" @click="setRoadviewRoad()"></div>

                  <div class="fOption">
                    <ul>
                      <li><span class="spot blue"></span>여유</li>
                      <li><span class="spot org"></span>혼잡</li>
                      <li><span class="spot red"></span>매우혼잡</li>
                    </ul>
                  </div>
                </div>
              </div>
              <!--//지도-->

              <div class="parkPopup" v-bind:class="{ active: toggle }">
                <div class="parkHead">
                  <p>{{ def.PARKING_NM }} ({{ def.PARKING_DIV_NM }})</p>
                </div>
                <div class="parkCont">
                  <img :src="checkImg(def.REPO_ID, def.FILE_PATH, def.SAVE_NM, def.FILE_EXT)" alt="주차장이미지" />
                  <div class="table park-table">
                    <table>
                      <caption>
                        공영주차장 상세정보
                      </caption>
                      <colgroup>
                        <col style="width: 25%" />
                        <col style="width: 25%" />
                        <col style="width: 25%" />
                        <col style="width: 25%" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <th scope="row">주차면수</th>
                          <td>{{ def.CELL_CNT }}</td>
                          <th scope="row">주차 가용대수</th>
                          <td v-if="def.PARK_COUNT == null">0</td>
                          <td v-else>{{ def.PARK_COUNT }}</td>
                        </tr>
                        <tr>
                          <th scope="row">장애인주차</th>
                          <td v-if="def.HNDCAP_CELL_CNT == null">0</td>
                          <td v-else>{{ def.HNDCAP_CELL_CNT }}</td>
                          <th scope="row">전기차 주차</th>
                          <td v-if="def.ELEC_CELL_CNT == null">0</td>
                          <td v-else>{{ def.ELEC_CELL_CNT }}</td>
                        </tr>
                        <tr>
                          <th scope="row">주소</th>
                          <td colspan="3" class="txt-left">{{ def.CELL_ADDR_LOAD }}</td>
                        </tr>
                        <tr>
                          <th scope="row">일반요금</th>
                          <td colspan="3">
                            <div class="table sky-table">
                              <table>
                                <caption>
                                  일반요금 상세정보
                                </caption>
                                <template v-if="this.def.PARKING_ID == 4">
                                  <thead>
                                    <tr>
                                      <th scope="col">최초60분</th>
                                      <th scope="col">10분당</th>
                                      <th scope="col">일일요금</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>600원</td>
                                      <td>250원</td>
                                      <td>{{ def.DAY_PARKING_AMT | comma }}원</td>
                                    </tr>
                                  </tbody>
                                </template>
                                <template v-else>
                                  <thead>
                                    <tr>
                                      <th scope="col">최초{{ def.DFLT_TM | comma }}분</th>
                                      <th scope="col">{{ def.INTVL_TM | comma }}분당</th>
                                      <th scope="col">일일요금</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>{{ def.DFLT_AMT | comma }}원</td>
                                      <td>{{ def.INTVL_AMT | comma }}원</td>
                                      <td>{{ def.DAY_PARKING_AMT | comma }}원</td>
                                    </tr>
                                  </tbody>
                                </template>
                              </table>
                            </div>
                          </td>
                        </tr>
                        <!-- 이용시간: ID 1~7 (전체주차장)은 24시간 유료운영, 그 외는 기존 주간/야간 설정 유지보수를 위해 보류 -->
                        <tr>
                          <th scope="row">이용시간</th>
                          <td colspan="3">
                            <div class="table sky-table">
                              <table>
                                <caption>이용시간 상세정보</caption>
                                <thead>
                                <tr>
                                  <template v-if="def.ANYHOUR_RUN_YN === '24시간운영함'">
                                    <th scope="col">평일, 주말 및 공휴일</th>
                                  </template>
                                  <!-- 기존설정 이나 신규 주차장 고려하여 기존 로직 주간/야간 일부 유지 -->
                                  <template v-else>
                                    <th scope="col">주간</th>
                                    <th scope="col">야간</th>
                                  </template>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                  <template v-if="def.ANYHOUR_RUN_YN === '24시간운영함'">
                                    <td>24시간 유료 운영</td>
                                  </template>
                                  <template v-else>
                                    <td>08:00~20:00</td>
                                    <td>20:00~08:00</td>
                                  </template>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <button type="button" class="toggleBtn" v-on:click="toggleElement">
                  <span class="hidden">토글버튼</span>
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import KakaoMap from '../../../components/KakaoMap.vue';
import axios from '../../../util/axios';

export default {
  data() {
    return {
      menuItem1: true,
      menuItem2: false,
      menuItem3: false,
      isClass1: true,
      isClass2: false,
      isClass3: false,
      toggle: false,
      active: false,
      overlayOn: false,
      lCategory: '대분류',
      mCategory: '중분류',
      sCategory: '소분류',

      distance: '',
      def: '',
      markers: [],
      parkingList: [],
      parkingLocationValue: [],
      positons: [],
      customOverlay: [],
      mapCenterPosition: [37.2719952, 127.4348221],
      marker: null,
      map: null,
      ckImg: null,
      imageSize: null,
      rv: null,
      rvClient: null,
      container: null,
      userLat: 37.2819952,
      userLng: 127.4448221,
      kakaoVali: -1,
    };
  },

  components: {
    KakaoMap,
  },

  mounted() {
    this.getParkingList();
  },

  methods: {
    async getParkingList() {
      const res = await axios('get', '/api/parking/map.json');
      this.parkingList = res.data.parkingMapList;
    },

    checkImg(repoId, filePath, saveNm, fileExt) {
      if (repoId == null || filePath == null || saveNm == null || fileExt == null) {
        return '../../../src/assets/images/main/noImage.png';
      } else {
        return '/api/parking/atchfile/' + repoId + '/' + filePath + '/' + saveNm + '.' + fileExt;
      }
    },

    toggleElement() {
      this.toggle = !this.toggle;
      for (let i = 0; i < this.markers.length; i++) {
        this.customOverlay[i].setMap(null);
        kakao.maps.event.addListener(this.markers[i], 'mouseout', () => {
          // 마커 호버아웃 이벤트
          this.customOverlay[i].setMap(null);
        });
      }
    },

    //kakao에서 markers 만든 후 클릭 이벤트 추가
    kakaoMapMarker(marker, map, positions) {
      this.markers = marker;
      this.map = map;
      this.positions = positions;

      for (let i = 0; i < this.markers.length; i++) {
        if (this.parkingList[i].PARK_COUNT == null) {
          this.parkingList[i].PARK_COUNT = 0;
        } else {
          this.parkingList[i].PARK_COUNT = this.parkingList[i].PARK_COUNT < 0 ? 0 : this.parkingList[i].PARK_COUNT;
        }

        const customContent =
          '<div class="mapCustomOverlay-box" style="min-height:0; width:200px;">' +
          '<dl style="margin-bottom: 0px;"><dt>[' +
          this.parkingList[i].PARKING_DIV_NM +
          '] ' +
          this.parkingList[i].PARKING_NM +
          '</dt></dl>' +
          '</div>';
        this.customOverlay[i] = new kakao.maps.CustomOverlay({
          position: this.positions[i],
          content: customContent,
          xAnchor: 0.017,
          yAnchor: 0.1,
        });

        kakao.maps.event.addListener(this.markers[i], 'mouseover', () => {
          // 마커 호버 이벤트
          this.customOverlay[i].setMap(this.map);
        });
        kakao.maps.event.addListener(this.markers[i], 'click', () => {
          this.makeClickListener(i, this.customOverlay[i]);
        });
        kakao.maps.event.addListener(this.markers[i], 'mouseout', () => {
          // 마커 호버아웃 이벤트
          this.customOverlay[i].setMap(null);
        });
      }

      //로드뷰를 표시할 div
      const rvContainer = document.getElementById('roadview');
      // 지도와 로드뷰를 감싸고 있는 div
      this.container = document.getElementById('mapContainer');

      // 로드뷰 객체를 생성
      this.rv = new kakao.maps.Roadview(rvContainer);

      // 좌표로부터 로드뷰 파노라마 ID를 가져올 로드뷰 클라이언트 객체를 생성
      this.rvClient = new kakao.maps.RoadviewClient();

      // 로드뷰에 좌표가 바뀌었을 때 발생하는 이벤트를 등록
      kakao.maps.event.addListener(this.rv, 'position_changed', () => {
        // 현재 로드뷰의 위치 좌표를 얻어옵니다
        const rvPosition = this.rv.getPosition();

        // 지도의 중심을 현재 로드뷰의 위치로 설정합니다
        this.map.setCenter(rvPosition);

        // 지도 위에 로드뷰 도로 오버레이가 추가된 상태이면
        if (this.overlayOn) {
          // 마커의 위치를 현재 로드뷰의 위치로 설정합니다
          this.marker.setPosition(rvPosition);
        }
      });

      // 마커 이미지를 생성합니다
      var rvMarkImage = new kakao.maps.MarkerImage(
        'https://t1.daumcdn.net/localimg/localimages/07/2018/pc/roadview_minimap_wk_2018.png',
        new kakao.maps.Size(37, 44),
        {
          // 스프라이트 이미지를 사용합니다.
          // 스프라이트 이미지 전체의 크기를 지정하고
          spriteSize: new kakao.maps.Size(1666, 168),
          // 사용하고 싶은 영역의 좌상단 좌표를 입력합니다.
          // background-position으로 지정하는 값이며 부호는 반대입니다.
          spriteOrigin: new kakao.maps.Point(705, 114),
          offset: new kakao.maps.Point(13, 46),
        },
      );

      // 드래그가 가능한 마커를 생성합니다
      const mapCenter = new kakao.maps.LatLng(this.userLat, this.userLng);

      this.marker = new kakao.maps.Marker({
        image: rvMarkImage,
        position: mapCenter,
        draggable: true,
      });

      // 마커에 dragend 이벤트를 등록합니다
      kakao.maps.event.addListener(this.marker, 'dragend', () => {
        // 현재 마커가 놓인 자리의 좌표입니다
        var position = this.marker.getPosition();

        // 마커가 놓인 위치를 기준으로 로드뷰를 설정합니다
        this.toggleRoadview(position);
      });

      //지도에 클릭 이벤트를 등록합니다
      kakao.maps.event.addListener(this.map, 'click', mouseEvent => {
        // 지도 위에 로드뷰 도로 오버레이가 추가된 상태가 아니면 클릭이벤트를 무시합니다
        if (!this.overlayOn) {
          return;
        }

        // 클릭한 위치의 좌표입니다
        var position = mouseEvent.latLng;

        // 마커를 클릭한 위치로 옮깁니다
        this.marker.setPosition(position);

        // 클락한 위치를 기준으로 로드뷰를 설정합니다
        this.toggleRoadview(position);
      });

      this.myPlace();
    },

    myPlace() {
      let locPosition = null;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            this.userLat = position.coords.latitude;
            this.userLng = position.coords.longitude;

            locPosition = new kakao.maps.LatLng(this.userLat, this.userLng);

            this.displayMarker(locPosition);
          },
          err => {
            locPosition = new kakao.maps.LatLng(this.userLat, this.userLng);
            this.displayMarker(locPosition);
          },
        );
      } else {
        // HTML5의 GeoLocation을 지원하지 않는 브라우저에서 마커 표시 위치와 인포윈도우 내용을 설정합니다

        locPosition = new kakao.maps.LatLng(this.userLat, this.userLng);

        this.displayMarker(locPosition);
      }
    },

    displayMarker(locPosition) {
      const ma = new kakao.maps.Marker({
        map: this.map,
        position: locPosition,
      });
      this.map.setCenter(locPosition);
    },

    makeClickListener(idx, customOverlay) {
      // 로드뷰 오버레이 나왓을시 마커 클릭 안되게함.
      if (this.overlayOn) {
        return null;
      }

      kakao.maps.event.addListener(this.markers[idx], 'mouseout', () => {
        customOverlay.setMap(this.map);
      });
      if (this.toggle == true) {
        for (let i = 0; i < this.customOverlay.length; i++) {
          if (i != idx) {
            kakao.maps.event.addListener(this.markers[i], 'mouseout', () => {
              this.customOverlay[i].setMap(this.null);
            });
            this.customOverlay[i].setMap(null);
          }
        }
      }

      this.def = this.parkingList[idx];
      if (this.def.PARKING_NM == '남천상가') {
        this.def.DFLT_AMT = 600;
        this.def.INTVL_AMT = 250;
      }
      this.toggle = true;



      this.checkImg(this.def.REPO_ID, this.def.FILE_PATH, this.def.SAVE_NM, this.def.FILE_EXT);
    },

    // 확대축소 레벨 별 이미지사이즈 저장
    distanceCheck() {
      const searchDistance = this.distance;

      if (searchDistance == '500') {
        this.setMarkersWithinKm(0.5);
      } else if (searchDistance == '1000') {
        this.setMarkersWithinKm(1.0);
      } else {
        this.markers.map(marker => marker.setMap(this.map));
        const bounds = new kakao.maps.LatLngBounds();
        for (let i = 0; i < this.markers.length; i++) {
          bounds.extend(this.markers[i].getPosition());
        }
        this.map.setBounds(bounds);
      }
    },

    setMarkersWithinKm(km) {
      if (this.markers != []) {
        this.markers.map(marker => marker.setMap(null));
      }

      const bounds = new kakao.maps.LatLngBounds();

      for (let i = 0; i < this.markers.length; i++) {
        const _pos = this.markers[i].getPosition();
        if (this.getDistanceFromLatLonInKm(_pos.getLat(), _pos.getLng(), this.userLat, this.userLng) <= km) {
          this.markers[i].setMap(this.map);
          bounds.extend(_pos);
        }
      }
      if (bounds.ha != Infinity) {
        this.map.setBounds(bounds);
      }
    },

    getDistanceFromLatLonInKm(lat1, lng1, lat2, lng2) {
      // lat1, lng1 비교대상 위치정보  || lat2, lng2 기준 위치정보
      // Radius of the earth in km
      var R = 6371;
      // deg2rad below
      var dLat = this.deg2rad(lat2 - lat1);
      var dLon = this.deg2rad(lng2 - lng1);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      // Distance in km
      var d = R * c;

      return d;
    },

    deg2rad(x) {
      return x * (Math.PI / 180);
    },

    toggleRoadview(position) {
      this.rvClient.getNearestPanoId(position, 50, panoId => {
        // 파노라마 ID가 null 이면 로드뷰를 숨깁니다
        if (panoId === null) {
          this.toggleMapWrapper(true, position);
        } else {
          this.toggleMapWrapper(false, position);

          // panoId로 로드뷰를 설정합니다
          this.rv.setPanoId(panoId, position);
        }
      });
    },

    // 지도를 감싸고 있는 div의 크기를 조정하는 함수입니다
    toggleMapWrapper(active, position) {
      if (active) {
        // 지도를 감싸고 있는 div의 너비가 100%가 되도록 class를 변경합니다
        this.container.className = '';

        // 지도의 크기가 변경되었기 때문에 relayout 함수를 호출합니다
        this.map.relayout();

        // 지도의 너비가 변경될 때 지도중심을 입력받은 위치(position)로 설정합니다
        this.map.setCenter(position);
      } else {
        // 지도만 보여지고 있는 상태이면 지도의 너비가 50%가 되도록 class를 변경하여
        // 로드뷰가 함께 표시되게 합니다
        if (this.container.className.indexOf('view_roadview') === -1) {
          this.container.className = 'view_roadview';

          // 지도의 크기가 변경되었기 때문에 relayout 함수를 호출합니다
          this.map.relayout();

          // 지도의 너비가 변경될 때 지도중심을 입력받은 위치(position)로 설정합니다
          this.map.setCenter(position);
        }
      }
    },

    // 지도 위의 로드뷰 도로 오버레이를 추가,제거하는 함수입니다
    toggleOverlay(active) {
      const position = this.map.getCenter();

      if (active) {
        this.overlayOn = true;

        // 지도 위에 로드뷰 도로 오버레이를 추가합니다
        this.map.addOverlayMapTypeId(kakao.maps.MapTypeId.ROADVIEW);

        // 지도 위에 마커를 표시합니다
        this.marker.setMap(this.map);

        // 마커의 위치를 지도 중심으로 설정합니다
        this.marker.setPosition(position);

        // 로드뷰의 위치를 지도 중심으로 설정합니다
        this.toggleRoadview(position);
      } else {
        this.overlayOn = false;

        // 지도 위의 로드뷰 도로 오버레이를 제거합니다
        this.map.removeOverlayMapTypeId(kakao.maps.MapTypeId.ROADVIEW);

        // 지도 위의 마커를 제거합니다
        this.marker.setMap(null);
      }
    },

    // 지도 위의 로드뷰 버튼을 눌렀을 때 호출되는 함수입니다
    setRoadviewRoad() {
      this.active = !this.active;
      const position = this.map.getCenter();

      // 버튼이 눌린 상태가 아니면
      if (this.active) {
        // 로드뷰 도로 오버레이가 보이게 합니다
        this.toggleOverlay(true);
      } else {
        // 로드뷰 도로 오버레이를 제거합니다
        this.toggleOverlay(false);
        this.container.className = '';
        this.map.relayout();
        this.map.setCenter(position);
      }
    },

    closeRoadview() {
      const position = this.marker.getPosition();
      this.toggleMapWrapper(true, position);
    },

    detailInfo(item) {
      this.popShow = true;
      this.parkingModalInfo = item;
      this.parkingLocation = [item];
      console.log('[모달 데이터]', item);
    },
  },
};
</script>
<style lang="scss">
.mapWH100 {
  width: 100%;
  height: 100%;
}

// 마커 마우스 오버시 주차장 명 출력
#map .mapCustomOverlay-box {
  position: absolute;
  top: -90px;
  left: -95px;
  border-radius: 5px;
  border: solid 1px #1b2c46;
  overflow: hidden;
}
#map .mapCustomOverlay-box dl dt {
  position: relative;
  height: 30px;
  padding: 5px 96px 5px 8px;
  background: #1b2c46;
  color: #fff;
  text-align: left;
  font-size: 13px;
}
#map .mapCustomOverlay-box dl dd {
  padding: 8px 10px;
  background: #fff;
  color: #0a0a0a;
  text-align: center;
  font-size: 13px;
}
#mapContainer {
  overflow: hidden;
  height: 700px;
  border-radius: 3px;
  border: 1px solid #bbb;
  position: relative;
}

#parkingMapWrapper {
  width: 100%;
  height: 700px;
  z-index: 1;
}
#rvWrapper {
  width: 50%;
  height: 700px;
  top: 0;
  right: 0;
  position: absolute;
  z-index: 0;
}
#mapContainer.view_roadview #parkingMapWrapper {
  width: 50%;
}
#roadviewControl {
  position: absolute;
  top: 5px;
  left: 5px;
  width: 42px;
  height: 42px;
  z-index: 1;
  cursor: pointer;
  background: url(https://t1.daumcdn.net/localimg/localimages/07/2018/pc/common/img_search.png) 0 -450px no-repeat;
}
#roadviewControl.active {
  background-position: 0 -350px;
}

@media screen and (max-width: 768px) {
  #mapContainer {
    height: 500px;
  }

  #mapWrapper {
    height: 500px;
  }
  #rvWrapper {
    height: 500px;
  }
}
</style>
